import { styled } from "styled-components";
import { Colors, ButtonVariants, AltButtonVariants } from "../constants";
import { motion } from "framer-motion";

const Wrapper = styled(motion.button)`
  display: flex;
  background: ${Colors.Red};
  border-radius: 16px;
  color: ${Colors.Tan};
  padding: 16px 0;
  outline: none;
  border: none;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-family: "Space Grotesk", sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  box-shadow: 0 6px 0px ${Colors.RedDark};
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  line-height: 100%;
`;

const Button = ({ onClick, children, type }) => {
  return (
    <Wrapper
      variants={type === "secondary" ? AltButtonVariants : ButtonVariants}
      initial={"initial"}
      whileHover={"whileHover"}
      whileTap={"whileTap"}
      onClick={onClick}
      type={type}
    >
      {children}
    </Wrapper>
  );
};

export default Button;
